// Actions
export const ADD_WALK_STEP = 'ADD_WALK_STEP_WALKTHROUGH'
export const NEXT_STEP = 'NEXT_STEP_WALKTHROUGH'
export const PREVIOUS_STEP = 'PREVIOUS_STEP_WALKTHROUGH'
export const CLEAR_STEPS = 'CLEAR_STEPS_WALKTHROUGH'
